<script>
export let region
</script>
<div class="card card--region">
	<div class="card__content">
		<div class="card__title">
			<h3>{region.title}</h3>
		</div>
	</div>
</div>
